var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 300,
    height: 300,
    viewBox: "0 0 300 300",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #bdc2d4;\n        fill-rule: evenodd;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M150.528,36.457A115.044,115.044,0,1,0,265.571,151.5,115.089,115.089,0,0,0,150.528,36.457ZM124.56,201.705H102.291V130.1H124.56v71.607ZM113.465,120.34a12.9,12.9,0,1,1,12.905-12.9A12.912,12.912,0,0,1,113.465,120.34Zm94.427,81.365H185.7V166.846c0-8.263-.158-18.964-11.568-18.964-11.567,0-13.377,9.049-13.377,18.413v35.41h-22.19V130.1h21.325v9.757h0.314c2.912-5.587,10.23-11.488,21.01-11.488,22.584,0,26.676,14.793,26.676,34.072v39.266Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.a7bb706a43a05549ad0d2033e0fd1d20.svg";
export { ForwardRef as ReactComponent };